module.exports = __webpack_public_path__ + "assets/img/box-1.578f368f.png";